import { useRef } from 'react'

import ProductReview from '@/ts/interfaces/product/ProductReview'

import ReviewsList from './includes/ReviewsList'
import ReviewsOverview from './includes/ReviewsOverview'

function Reviews({ reviews, rating, votes }: ReviewsProps) {
  const anchorElement = useRef<HTMLDivElement>(null)

  return (
    <>
      {reviews.length > 0 && (
        <div ref={anchorElement} className="relative pt-2 mt-10 box">
          <h2 className="mb-4 text-xl font-medium md:text-2xl">Recenzje</h2>
          <div className="flex flex-col items-start space-y-4 xl:space-y-0 xl:space-x-8 xl:flex-row">
            <ReviewsOverview {...{ rating, reviews, votes }} />
            <ReviewsList reviews={reviews} anchorElement={anchorElement} />
          </div>
        </div>
      )}
    </>
  )
}

interface ReviewsProps {
  reviews: ProductReview[]
  rating: number
  votes: number
}

export default Reviews
